import type { SxProps, Theme } from '@mui/material';

export const maintenancePageWrapperSx: SxProps<Theme> = {
  gap: 2,
  minHeight: '100vh',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  background: (theme) => theme.palette.grey.A900 ?? 'transparent',
  '& svg': {
    color: (theme) => theme.palette.primary.dark,
  },
};
export const maintenancePageTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  paddingTop: '2rem',
  fontSize: '2.875rem',
};

export const maintenancePageLabelSx: SxProps<Theme> = {
  width: '80%',
  paddingTop: '1rem',
  textAlign: 'center',
};
